import React from "react";

var Item = function Item(_ref) {
  var className = _ref.className,
      x = _ref.x,
      y = _ref.y,
      openDirection = _ref.openDirection,
      itemNumber = _ref.itemNumber,
      children = _ref.children,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-item-number": itemNumber,
    "data-x": x,
    "data-y": y,
    "data-open-direction": openDirection,
    style: style
  }, children);
};

var Header = function Header(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-annotated-item-header": true
  }, children);
};

Item.Header = Header;
Header.displayName = "AnnotatedScreenshot-Item-Header";

var Content = function Content(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-annotated-item-content": true
  }, children);
};

Item.Content = Content;
Content.displayName = "AnnotatedScreenshot-Item-Content";
export default Item;